import { defaultTheme } from "@cobee/cobee-ui";

const styles = {
  textContainer: {
    marginRight: defaultTheme.spacing(16),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  titleStyle: {
    fontSize: "36px",
    fontWeight: 600,
    width: "413px",
    lineHeight: "54px",
    marginBottom: defaultTheme.spacing(2),
  },
  subtitleStyle: {
    color: defaultTheme.palette.grey[700],
  },
};

export default styles;
